module.exports = __webpack_public_path__ + "static/img/bananwr.a92fce58.webp";